import { Transacao } from './transacao.model'

export class Venda extends Transacao {
cancelada: boolean
    get operacaoCancelada() {

        if (this.cancelada === true) {
            this.tipoDeVenda = 'Cancelamento';

        }
        return this.tipoDeVenda;
    }

}




// WEBPACK FOOTER //
// ./src/app/pkw-data/collect/extrato/venda.model.ts